module.exports = __webpack_public_path__ + "static/media/image-28.aacf81e1.png";